import React from 'react';

import { Container, Content } from './styles';

interface ModalProps {
  maxWidth: number;
  closeModal: () => void;
}

export interface SubModalProps {
  closeModal: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Modal: React.FC<ModalProps> = ({ maxWidth, closeModal, children }) => {
  return (
    <Container>
      <Content maxWidth={maxWidth}>{children}</Content>
    </Container>
  );
};

export default Modal;
